import React from "react";
import AddQuestion from './AddQuestion.jsx';
import QuestionList from './QuestionList.jsx';

export default function AddManageQuestionnaire() {
  
  return (
    <>
        <AddQuestion/>
        <QuestionList/>
    </>
    
  );
}
